import React, { useState } from "react";
import {
  Rocket,
  Shield,
  MessageSquare,
  FileText,
  Image,
  AlertTriangle,
  ChevronDown,
  ChevronRight,
} from "lucide-react";

const ICON_MAP = {
  Rocket,
  Shield,
  MessageSquare,
  FileText,
  Image,
  AlertTriangle,
};

const DocSidebar = ({ categories, activeSection, onSelect }) => {
  const [expanded, setExpanded] = useState(() => {
    const initial = {};
    categories.forEach((c) => { initial[c.id] = true; });
    return initial;
  });

  const toggleCategory = (catId) => {
    setExpanded((prev) => ({ ...prev, [catId]: !prev[catId] }));
  };

  return (
    <nav className="w-60 flex-shrink-0 border-r border-gray-200 bg-white overflow-y-auto">
      <div className="px-4 pt-5 pb-3">
        <h3 className="text-[11px] font-bold uppercase tracking-widest text-gray-400">API Reference</h3>
      </div>

      <div className="px-2 pb-6 space-y-0.5">
        {categories.map((cat) => {
          const Icon = ICON_MAP[cat.icon] || FileText;
          const isExpanded = expanded[cat.id];
          const hasItems = cat.items && cat.items.length > 0;
          const isSingle = hasItems && cat.items.length === 1;
          const isActive = cat.items?.some((item) => item.id === activeSection);

          if (isSingle) {
            const item = cat.items[0];
            return (
              <button
                key={cat.id}
                onClick={() => onSelect(item.id)}
                className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-left text-[13px] font-medium transition-colors ${
                  activeSection === item.id
                    ? "bg-[#048AAD]/10 text-[#048AAD]"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                <Icon size={15} className={activeSection === item.id ? "text-[#048AAD]" : "text-gray-400"} />
                {cat.title}
              </button>
            );
          }

          return (
            <div key={cat.id}>
              <button
                onClick={() => toggleCategory(cat.id)}
                className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-left text-[13px] font-medium transition-colors ${
                  isActive && !isExpanded
                    ? "bg-[#048AAD]/10 text-[#048AAD]"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                <Icon size={15} className={isActive ? "text-[#048AAD]" : "text-gray-400"} />
                <span className="flex-1">{cat.title}</span>
                {hasItems && (
                  isExpanded ? <ChevronDown size={13} className="text-gray-400" /> : <ChevronRight size={13} className="text-gray-400" />
                )}
              </button>

              {isExpanded && hasItems && (
                <div className="ml-5 pl-3 border-l border-gray-200 mt-0.5 space-y-0.5">
                  {cat.items.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => onSelect(item.id)}
                      className={`w-full text-left px-3 py-1.5 rounded-md text-[12px] transition-colors ${
                        activeSection === item.id
                          ? "text-[#048AAD] font-semibold bg-[#048AAD]/5"
                          : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
                      }`}
                    >
                      {item.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default DocSidebar;
